const getAppliedFilters = ({ report: { filters } }, dataKey) => ({
  appliedFilters: filters.active.applied[dataKey],
  appliedFiltersRequestStatus: filters.active.requestStatus,
});

export default getAppliedFilters;
